import * as React from 'react';
import { getCommunityMembers } from '@/api/communities';
import { useQuery } from '@tanstack/react-query';

import { useDialog } from '@/hooks/v2/use-dialog';
import { useUser } from '@/hooks/v2/use-user';
import { MembersTable } from './components/members-table';

export function CommunityMembersPage(): React.JSX.Element {
  const dialog = useDialog();
  const { community } = useUser();
  if (!community) {
    return <div>No community found</div>;
  }
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['members', community?.id],
    queryFn: () => getCommunityMembers(community?.id),
  });

  const handleOnSuccess = React.useCallback(async () => {
    await refetch();
    dialog.handleClose();
  }, [dialog, refetch]);

  const members = data?.members;
  return <MembersTable loading={isLoading} onCreated={handleOnSuccess} rows={members ?? []} />;
}
